import { PrimaryButton } from '@/components/button/button-component';
import propTypes from 'prop-types';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import { passwordRules, requiredValidationMessage } from '@/utils/validations';
import { MdLockOutline } from 'react-icons/md';
import styled from 'styled-components';

/**
 * Update Password form
 * @param {object} props - The props
 * @param {loading} props.loading - The loading state
 * @returns {JSX.Element}
 */
const UpdatePasswordForm = ({ loading }) => (
  <Container>
    <Input
      iconLeft={<MdLockOutline />}
      label="Create New Password"
      placeholder="password"
      name="password"
      disabled={loading}
      registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          passwordRules.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
      type="password"
    />
    <Input
      iconLeft={<MdLockOutline />}
      label="Confirm New Password"
      placeholder="password"
      type="password"
      icon="password"
      name="confirmPassword"
      disabled={loading}
      registerOptions={{
        required: requiredValidationMessage,
        /**
         * Validate password match
         * @param {string} value - The value of the input
         * @param {Function} getValues - The getValues function from React Hook Form
         * @returns {string} The error message
         */
        validate: (value, getValues) =>
          value === getValues('password') || 'Passwords do not match',
      }}
    />
    <PrimaryButton
      buttonWidth="100%"
      buttonHeight="48px"
      type="submit"
      loading={loading}
      title="UPDATE PASSWORD"
    />
  </Container>
);

const Container = styled.div`
  display: flex;
  padding-top: 24px;
  min-width: 420px;
  display: flex;
  flex-direction: column;
`;

UpdatePasswordForm.propTypes = {
  loading: propTypes.bool.isRequired,
};

export default UpdatePasswordForm;
